import React, { FC } from 'react';

import CardBase from '@components/1-atoms/Card';
import { Column, Row, Spacer } from '@components/1-atoms/Miscellaneous';
import Text from '@components/1-atoms/Text';


import { Button } from '@components/2-molecules/Buttons';

import { Info } from '@components/2-molecules';
import styled from '@emotion/native';
import * as utils from '@lib/utils';
import { View } from 'react-native';

import RevenueCatService from '@lib/subscription';


const Card = styled(CardBase)` `;

const Subscriptions = styled(View)`
    width: 100%;
`;


type Props = {
    data: Object;
    managementURL: string;
};

const ManageSubscription: FC<Props> = ({ managementURL, data }) => {

    const _manageSubscription = () => RevenueCatService.manageSubscription(managementURL);

    return (
        <Card>
            <Row>
                <Column>
                    <Text large>Manage your subscription</Text>
                </Column>
                <Spacer w={1} />
            </Row>
            <Spacer h={1.6} />

            <Subscriptions>
                {
                    [data].map((subscription: any, index: number) => {
                        return (
                            <View key={index}>
                                <Row>
                                    <Text>The current trial or subscription was purchased on <Text bold>{utils.formatDate(subscription?.updatedAt)}</Text> <Text>for the period ending on <Text bold>{utils.formatDate(subscription?.endDate)}</Text></Text>.</Text>
                                </Row>
                            </View>
                        )
                    })
                }
            </Subscriptions>
            <Spacer h={1.3} />

            <Info>We support the subscription methods that follow: Stripe (on the Web), Google Play Store (on Android).</Info>
            <Spacer h={1} />

            <Button inset outlined onPress={_manageSubscription}>MANAGE SUBSCRIPTION</Button>
        </Card>
    );
};

export default ManageSubscription;